import React, { useState } from "react";
import { format, parse } from "date-fns";
import { Calendar as CalendarIcon, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

// Australian-formatted (DD/MM/YYYY) date picker. value is a "YYYY-MM-DD" string or "".
export default function DatePickerAU({ value, onChange, minToday = false, allowedDays, placeholder = "Pick a date", testid = "date-picker" }) {
  const [open, setOpen] = useState(false);
  const selected = value ? parse(value, "yyyy-MM-dd", new Date()) : undefined;
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" data-testid={testid}
          className={`h-9 w-full justify-start gap-2 px-3 font-normal ${!value ? "text-muted-foreground" : ""}`}>
          <CalendarIcon className="h-4 w-4 shrink-0 text-kilted-gold" />
          <span className="flex-1 truncate text-left">{selected ? format(selected, "dd/MM/yyyy") : placeholder}</span>
          {value && (
            <span role="button" tabIndex={-1} aria-label="Clear date" data-testid={`${testid}-clear`}
              className="rounded-sm p-0.5 text-muted-foreground hover:bg-muted hover:text-foreground"
              onClick={(e) => { e.stopPropagation(); onChange(""); }}>
              <X className="h-3.5 w-3.5" />
            </span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start" data-testid={`${testid}-calendar`}>
        <Calendar
          mode="single"
          selected={selected}
          defaultMonth={selected}
          weekStartsOn={1}
          disabled={(d) => (minToday && d < today) || (Array.isArray(allowedDays) && !allowedDays.includes(d.getDay()))}
          onSelect={(d) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
